import React, { Component } from 'react';
import find from 'lodash/find';
import { Tabs, Tab } from 'react-bootstrap';
import Tags from './Tags';
import { MyTags } from './MyTags';
import TagCheck from './TagCheck';

const styles = {
  rootStyle: {
    className: '',
  },

  colorStyle: {
    className: 'tag-focus',
  },
};

class TagsComponent extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = {
      tabKey: 1,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.nextAccountDetails) {
      this.setState({ tabKey: 1 });
    }
  };
  getClass = (id) => {
    let labelStyle = styles.rootStyle.className;
    if (this.props.unTagSelected) {
      return labelStyle;
    }

    if (find(this.props.transactionTagData, (c) => c.tagId === id)) {
      labelStyle = styles.colorStyle.className;
    }
    return labelStyle;
  };

  handleSelect = (e) => {
    this.props.handleSelect(e);
    this.setState({ tabKey: e });
    this.forceUpdate();
  };

  render() {
    let tabDisplay;
    if (this.state.tabKey === 1) {
      tabDisplay = (
        <Tags
          assignTag={this.props.assignTag}
          data={this.props.categories}
          getClass={this.getClass}
          content={this.props.content}
          onTagInfoClick={this.props.onTagInfoClick}
          cssActiveClassForSelectedTags={
            this.props.cssActiveClassForSelectedTags
          }
        />
      );
    }
    if (this.state.tabKey === 2) {
      tabDisplay = (
        <MyTags
          data={this.props.tags}
          handleKeyPress={this.props.handleKeyPress}
          handleChangeOfTag={this.props.handleChangeOfTag}
          handleAddTagButton={this.props.handleAddTagButton}
          flagForAddTag={this.props.flagForAddTag}
          deleteTag={this.props.deleteTag}
          flagForEditTag={this.props.flagForEditTag}
          content={this.props.content}
          onTagInfoClick={this.props.onTagInfoClick}
          getClass={this.getClass}
          assignTag={this.props.assignTag}
          newTagInput={this.props.newTagInput}
          editTagInput={this.props.editTagInput}
          cssActiveClassForSelectedTags={
            this.props.cssActiveClassForSelectedTags
          }
          newTagValue={this.props.newTagValue}
        />
      );
    }
    return (
      <div
        className="col-xs1-24 col-sm1-24 col-md1-24 col-lg1-24 div-sidebar-content"
        style={{ height: '100%' }}
      >
        <Tabs
          activeKey={this.state.tabKey}
          onSelect={this.handleSelect}
          id="controlled-tab-example"
          bsStyle="pills"
        >
          <TagCheck
            rememberThisIconClickOpen={this.props.rememberThisIconClickOpen}
            toggleCheckBox={this.props.toggleCheckBox}
          />

          <Tab eventKey={1} title="Tags">
            {tabDisplay}
          </Tab>

          <Tab eventKey={2} title="My Tags">
            {tabDisplay}
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export { TagsComponent };
